<template>
  <div class="vx-row">
    

    <vx-card>
      <vs-button
          class="ml-5"
            icon="keyboard_backspace"
            @click="goBack"
            >Back</vs-button
          >
       <div class="text-right">

         {{ viewing_as_full_name ? 'Viewing As : ' +  viewing_as_full_name : null }}
       </div>

        <div class="text-center p-10">
          <template>
            <h5 class="text-dark-grey mb-16 text-center">
              What would you like to do?
            </h5>
            <div class="vx-row">

              <div class="vx-col w-1/3 md:w-1/4 xl:w-1/4">
                <router-link :to="client_user_id?{ name: 'views-client-and-client-user-campaign-view', params: { 'campaign_status': 'Live' , 'client_id': selected_client_id , 'client_user_id': client_user_id , 'client_user_full_name': encoded_viewing_as_full_name}}:{ name: 'views-client-campaign-view', params: { 'campaign_status': 'Live' , 'client_id': selected_client_id}}">
                  <vx-card class="client-vx-card">
                    <vs-row vs-w="12" class="">
                      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                        <feather-icon icon="FilmIcon" svgClasses="h-4 w-4" class="mr-3" />
                        <h5>Live Campaigns</h5>
                      </vs-col>

                    </vs-row>
                  </vx-card>
                </router-link>
              </div>


              <div class="vx-col w-1/3 md:w-1/4 xl:w-1/4">
                <router-link :to="client_user_id?{ name: 'views-client-and-client-user-campaign-view', params: { 'campaign_status': 'Completed' , 'client_id': selected_client_id , 'client_user_id': client_user_id , 'client_user_full_name': encoded_viewing_as_full_name}}:{ name: 'views-client-campaign-view', params: { 'campaign_status': 'Completed' , 'client_id': selected_client_id}}">

                  <vx-card class="client-vx-card">
                    <vs-row vs-w="12" class="">
                      <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                      </vs-col>
                      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                        <feather-icon icon="CheckIcon" svgClasses="h-4 w-4" class="mr-3" />
                        <h5>Completed Campaigns</h5>
                      </vs-col>
                      <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                      </vs-col>
                    </vs-row>
                  </vx-card>
                </router-link>
              </div>

              <div class="vx-col w-1/3 md:w-1/4 xl:w-1/4">
                <router-link :to="client_user_id?{ name: 'views-client-and-client-user-campaign-view', params: { 'campaign_status': 'Scheduled' , 'client_id': selected_client_id , 'client_user_id': client_user_id , 'client_user_full_name': encoded_viewing_as_full_name}}:{ name: 'views-client-campaign-view', params: { 'campaign_status': 'Scheduled' , 'client_id': selected_client_id}}">
                  <vx-card class="client-vx-card">
                    <vs-row vs-w="12" class="">
                      <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                      </vs-col>
                      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                        <feather-icon icon="GitCommitIcon" svgClasses="h-4 w-4" class="mr-3" />
                        <h5>Scheduled Campaigns</h5>
                      </vs-col>
                      <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                      </vs-col>
                    </vs-row>
                  </vx-card>
                </router-link>
              </div>

              <div class="vx-col w-1/3 md:w-1/4 xl:w-1/4">
                <router-link :to="client_user_id?{ name: 'views-client-and-client-user-campaign-view', params: { 'campaign_status': 'All' , 'client_id': selected_client_id , 'client_user_id': client_user_id , 'client_user_full_name': encoded_viewing_as_full_name}}:{ name: 'views-client-campaign-view', params: { 'campaign_status': 'All' , 'client_id': selected_client_id}}">
                  <vx-card class="client-vx-card">
                    <vs-row vs-w="12" class="">
                      <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                      </vs-col>
                      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                        <feather-icon icon="AlignCenterIcon" svgClasses="h-4 w-4" class="mr-3" />
                        <h5>All Campaigns</h5>
                      </vs-col>
                      <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                      </vs-col>
                    </vs-row>
                  </vx-card>
                </router-link>
              </div>

            </div>


          </template>
        </div>

      </vx-card>
    
  </div>
</template>

<script>
import defineAbilitiesFor from '@/config/abilities'
import vSelect from "vue-select";
export default {
  data: () => ({
    client_user_id:null,
    selected_client_id: null,
    viewing_as_full_name : null,
    encoded_viewing_as_full_name : null,
    clientUsers : null,
      sortedbyASC: true,
    totalItems:10,
    abilities : null,
    selected: [],
    log: [],
    clients: null,
    selected_id: null,
  }),
  components: {

    "v-select": vSelect
  },
  computed: {
  },
  watch: {
  },
  methods: {
     goBack: function() {
      this.$router.go(-1);
    }
  },
  mounted(){
    var self = this

if(self.$route.params.client_user_id != 'null' && self.$route.params.client_user_id != null){
  self.viewing_as_full_name =  atob(self.$route.params.client_user_full_name)
  self.encoded_viewing_as_full_name =  self.$route.params.client_user_full_name
  self.client_user_id =  self.$route.params.client_user_id
}
self.selected_client_id =  self.$route.params.client_id
  },
  created() {
       
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    });
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.pointer{
  cursor: pointer;
}

.item.expanded{
    background-color: white !important;
    color: black !important;
}

.tr-table-state-primary, .vs-table-primary .is-selected {
    background: none !important;
    box-shadow: none !important;
}


.tr-table-state-primary, .vs-table-primary .is-selected {
    color: #626262 !important;
    -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary),1)!important;
    box-shadow: 0 0 1px 0 rgba(var(--vs-primary),1)!important;
}

.address_th{
  padding: 30px;
}

.address_td{
  padding: 30px;
      font-weight: 500;
}
</style>

<style lang="stylus">
.con-expand-users
  .con-btns-user
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-userx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
